class testpdfCtrl {
    constructor($scope, httpRequest) {
        $scope.pdfParam = {}
        $scope.pdfParam.marginTop = 0,
        $scope.pdfParam.marginRight = 10,
        $scope.pdfParam.marginBottom = 0,
        $scope.pdfParam.marginLeft = 10,

        $scope.picParam = {}
        $scope.picParam.invoiceCode = '',
        $scope.picParam.invoiceNumber = '',
        $scope.listData = []

        $scope.get_bulidPdf = function () {
            httpRequest.post_bulidPdf($scope.pdfParam).then((res) => {
                window.open(`${host.etcloudIvatApp}common/common/getFile?fileKey=${res.data.value}`)
            })
        }
        $scope.get_list = function () {
            httpRequest.get_getFileInfoList($scope.picParam).then((res) => {
                $scope.listData = res.data.value
            })
        }
        $scope.showPic = function (id) {
            window.open(`${host.etcloudIvatApp}common/common/getFile?fileKey=${id}`)
        }
    }
}

testpdfCtrl.$inject = ['$scope', 'httpRequest']
export default testpdfCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/deduction/testpdfCtrl.js